import './rxjs-extensions';

import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { RadiobuttonComponent } from './radiobutton.component';
import { RadiobuttonRoutingModule } from './radiobutton.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RadiobuttonRoutingModule,
    ReactiveFormsModule,
  ],
  exports: [
    RadiobuttonComponent
  ],
  declarations: [
    RadiobuttonComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class RadiobuttonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: RadiobuttonModule,
      providers: [GenericdatasetService]
    };
  }
}
